import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import moment from 'moment';
import { formatReceived } from 'utils/formatValues';
import CRUDgeneric from 'utils/CRUDgeneric';

export const CRUDEvaluacionGeneralClock = CRUDgeneric('/relojchecador/evaluacion-cierre/');

export const URIEvaluacionErrores = '/relojchecador/evaluacion-cierre-errores/';

/**
 * POST evalua el mes
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const evaluar = async (id) => {
  try {
    const response = await API.post(`${'/relojchecador/evaluacion-cierre-evaluacion/'}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST evalua el mes
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const cierreDeMes = async (id) => {
  try {
    const response = await API.post(`${'/relojchecador/guardar-incidencia-evaluacion/'}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST evalúa un empleado individual en uno o más meses
 * @param {number[]} mesIds
 * @param {string[]} numerosDeEmpleado
 * @returns {Promise<object|null>}
 */
export const evaluarEmpleados = async (mesIds, numerosDeEmpleado) => {
  try {
    const response = await API.post('/relojchecador/evaluacion-cierre-evaluacion-empleados/', {
      mes_ids: mesIds,
      numeros_de_empleado: numerosDeEmpleado,
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Evaluacion General Reloj
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getEvaluacionGeneralReloj = async (params) => (
  CRUDEvaluacionGeneralClock.obtenerListaDeRegistros(params)
);

/**
 * POST genera y descarga reporte Excel flexible de evaluaciones
 * @param {string[]} numerosDeEmpleado
 * @param {string|null} fechaInicio  formato YYYY-MM-DD
 * @param {string|null} fechaFin     formato YYYY-MM-DD
 */
export const generarReporteEvaluacionesExcel = async (numerosDeEmpleado, fechaInicio, fechaFin) => {
  const payload = { numeros_de_empleado: numerosDeEmpleado };
  if (fechaInicio && fechaFin) {
    payload.fecha_inicio = fechaInicio;
    payload.fecha_fin = fechaFin;
  }
  const response = await API.post(
    '/relojchecador/reporte-evaluaciones-excel/',
    payload,
    { responseType: 'blob' },
  );
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'reporte_evaluaciones.xlsx');
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const formatEvaluacionById = (record) => {
  const _mes = record?.mes?.id;
  const date = moment().month(_mes - 1);
  const firstDay = date.clone().startOf('month');
  const lastDay = date.endOf('month');

  const dataFormatedById = {
    ...formatReceived(record),
    fecha_inicial: _mes ? firstDay.format('DD-MM-YYYY') : '',
    fecha_final: _mes ? lastDay.format('DD-MM-YYYY') : '',
    periodo_fiscal: record?.periodo_fiscal?.id ?? record?.periodo_fiscal,
    mes: _mes,
    periodo_de_nomina_detalle: record?.periodo_de_nomina_detalle?.id,
    tipos_de_nominas_empleados: record?.tipos_de_nominas_empleados?.id,
    estados_globales: record?.estados_globales?.id,
  };
  return dataFormatedById;
};
